import { ServerConfigService } from 'src/app/share/service/server-config.service';
import { DOCUMENT, isPlatformBrowser } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { AfterViewInit, Component, ElementRef, Inject, NgZone, OnDestroy, OnInit, Output, PLATFORM_ID, ViewChild, EventEmitter, Input } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { GlobalComponentService } from '@techmore/global';
import * as moment from 'moment';
import { BehaviorSubject, combineLatest, fromEvent, Observable, of, ReplaySubject, Subject, Subscription } from 'rxjs';
import { switchMap, debounceTime, distinctUntilChanged, publishReplay, refCount, skip, filter, tap, map, take } from 'rxjs/operators';
import { AutoCompleteOptionsComponent } from 'src/app/share/component/auto-complete-options/auto-complete-options.component';
import { CommonHttpClientService } from 'src/app/share/service/common-http-client.service';
import { GENERATOR_ENV_TOKEN, GeneratorEnv } from 'src/app/web-generator/generator-env-token';
import { HotKeywordsService } from 'src/app/share/service/hot-keywords.service';
import { isNullOrUndefined } from 'util';
import { SEARCH_PARAM_KEYS } from '../../entity/itri-filter-search-param';
import { SearchForm } from '../../entity/search-form';
import { SearchOption, SearchOptions, CitySearchOption } from '../../entity/search-options';
import { ITRISearchResult, ITRISearchResultRecord } from '../../entity/search-result';
import { GALoggerService } from 'src/app/share/service/galogger.service';
import { DataSearchService } from '../../data-search.service';
import { checkIsMobile } from 'src/app/util';
import { chechArrayisMatchWithAnother } from 'src/app/share/pipe/match-another-array.pipe';

@Component({
  selector: 'app-data-search-form',
  templateUrl: './data-search-form.component.html',
  styleUrls: [
    './search-bar.scss',
    './cms-search-02.component.scss',
    './data-search-form.component.scss',
  ]
})
export class DataSearchFormComponent implements OnInit, AfterViewInit, OnDestroy {
  @ViewChild('searchResultRef', {static: false}) searchResultRef: ElementRef;
  @ViewChild('skACO', {static: false}) skACO: AutoCompleteOptionsComponent;
  /** server 分頁一頁資料數量 */
  protected limit$ = new BehaviorSubject<number>(checkIsMobile() ? 10 : 24);
  set limit(value: number) { this.limit$.next(value); }
  get limit(): number { return this.limit$.getValue(); }
  /** server 分頁資料位移量 */
  protected offset$ = new BehaviorSubject<number>(0);
  set offset(value: number) { this.offset$.next(value); }
  get offset() { return this.offset$.getValue(); }
  /** 排序欄位 */
  protected sort$ = new BehaviorSubject<'relevance'|'updateDate'|'viewCount'>('relevance');
  set sort(field: 'relevance'|'updateDate'|'viewCount') { this.sort$.next(field); }
  get sort(): 'relevance'|'updateDate'|'viewCount' { return this.sort$.getValue(); }
  /** 排序 */
  protected order$ = new BehaviorSubject<'desc' | 'asc'>('desc');
  set order(o: 'asc' | 'desc') { this.order$.next(o); }
  get order(): 'asc' | 'desc' { return this.order$.getValue(); }
  /** 關鍵字 */
  protected keyword$ = new BehaviorSubject<string>('');
  set keyword(s: string) {
    this.keyword$.next(s);
    this.isFuzzyMode = false;
    this.offset = 0;
  }
  get keyword(): string { return this.keyword$.getValue(); }
  /** 進階搜尋 */
  protected query$ = new BehaviorSubject<any>(null);
  set query(term: any) {
    if (term) {
      for (const k in term) {
        if (isNullOrUndefined(term[k])) {
          delete term[k];
        }
      }
      if (!Object.keys(term).length) {
        term = null;
      }
    }
    this.query$.next(term);
    this.offset = 0;
  }
  get query(): any { return this.query$.getValue(); }
  /** 使用模糊查詢，否就是精準查詢 */
  protected isFuzzyMode$ = new BehaviorSubject<boolean>(false);
  set isFuzzyMode(isFussy: boolean) { this.isFuzzyMode$.next(isFussy); }
  get isFuzzyMode() { return this.isFuzzyMode$.value; }
  /** server 分頁所有資料頁數 */
  totalPages: number;
  /** server 分頁所有資料筆數 */
  total: number;
  /** 目前所在頁次 */
  get currentPage() { return Math.ceil(this.offset / this.limit) + 1; }
  /** server 分頁的查詢結果 */
  searchResult: ITRISearchResultRecord[];
  protected routerEvtSubc: Subscription;
  protected dataSubscription: Subscription;
  protected keepUrlSubscription: Subscription;
  // ===================以上都是分頁的程式碼===================
  /** 是瀏覽器端渲染 */
  isBrowser: boolean;
  /** 是否使用 (GTM)log */
  @Input() isUseLog = false;
  /** 使用者用了關鍵字查詢當下的時間戳記 */
  searchWithKeywordTimeStamp: string;
  /** 查詢關鍵字 */
  searchKeyword: string;
  /** 關鍵字變化通知器 */
  protected searchKeyword$ = new Subject<string>();
  /** 關鍵字檢索選項 */
  keywordsOptions: string[] = [];
  /** 查詢主題 */
  searchSubject: SearchOption;
  /** 查詢資料表單即時篩選項目參數 */
  searchFilter: SearchForm = {};
  get hasAnySearchFilter() { return Object.keys(this.searchFilter).length || (this.query && this.query.subject); }
  /** 查詢條件 key */
  readonly queryKeys: string[] = SEARCH_PARAM_KEYS;
  /** 顯示在已選篩選列表上的條件 key */
  readonly showedFilterConditionKeys: string[] = ['subject', 'format', 'fetchIndex', 'rights', 'desRights', 'city', 'dist'];
  /** 查詢列表所有的選項 */
  protected allOption$ = new ReplaySubject<SearchOptions>();
  /** 分類選項 */
  SUBJECT_OPTIONS: SearchOption[];
  /** 數位物件類型選項 */
  FORMAT_OPTIONS: SearchOption[];
  /** 資料來源單位選項 */
  FETCH_INDEX_OPTIONS: SearchOption[];
  /** 數位物件授權選項 */
  RIGHTS_OPTIONS: SearchOption[];
  /** 開放授權 */
  OPENED_RIGHTS: SearchOption[];
  /** 不可商用授權 */
  SHARED_RIGHTS: SearchOption[];
  /** 封閉授權 */
  CLOSED_RIGHTS: SearchOption[];
  /** 文字授權選項 */
  DES_RIGHTS_OPTIONS: SearchOption[];
  /** 縣市選項 */
  CITY_OPTIONS: CitySearchOption[];
  /** 區域選項 */
  DIST_OPTIONS: SearchOption[];
  /** 相關搜尋詞 */
  correlation: string[];
  /** 關鍵字檢索訂閱 */
  protected filterOptionSubc: Subscription;
  /** 表單送出前的鉤子 */
  @Output() beforeLoadData = new EventEmitter<void>();
  /** 資料載入後的鉤子 */
  @Output() dataLoaded = new EventEmitter<void>();
  /** 路由參數被清空時拋出的事件 */
  @Output() formReset = new EventEmitter<void>();
  /** 是否將查詢參數保留到網址列上，預設為保留 */
  @Input() isKeepParamsToUrl = true;
  /** 是否需要發日誌 */
  needLog = false;
  /** 建檔單位選項 */
  createDeptOptions: string[] = [];
  /** 建檔單位變化通知器 */
  protected createDept$ = new BehaviorSubject<string>('');
  /** 建檔單位檢索訂閱 */
  protected createDeptFilterOptionSubc: Subscription;
  /** 螢幕大小縮放自動去更新limit */
  private updateLimitSubc: Subscription;
  /** 是否已經載入查詢參數用的選項 */
  hasLoadParamOptions = false;
  /** 載入資料實顯示的進度條動畫行程識別碼 */
  protected loadDataProcessUUID: string;

  constructor(
    protected route: ActivatedRoute,
    protected router: Router,
    @Inject(GENERATOR_ENV_TOKEN) protected generatorEnv: GeneratorEnv,
    protected commonHttp: CommonHttpClientService,
    @Inject(PLATFORM_ID) protected platformId: object,
    protected globalComponentService: GlobalComponentService,
    @Inject(DOCUMENT) protected document: Document,
    protected hotKeywordsService: HotKeywordsService,
    protected zone: NgZone,
    protected gALoggerService: GALoggerService,
    protected dataSearchService: DataSearchService,
    protected serverConfigService: ServerConfigService,
  ) {
    this.isBrowser = isPlatformBrowser(this.platformId);
  }

  ngOnInit() {
    if (this.isBrowser) {
      this.listenOnKeywordChange();
      this.listentOnCreateDeptChange();

      if (this.isKeepParamsToUrl) {
        this.initParamsFromUrl();
      }
      this.loadOptions();

      const queryObservable = this.genParamsChange$();
      this.loadDataOnParamsChange(queryObservable);
      if (this.isKeepParamsToUrl) {
        this.keepParamsToUrl(queryObservable);
      }
      this.listenOnClearParamRouteeEvt();
      this.startUpdateLimit();
    }
  }

  ngAfterViewInit(): void {
    const searchToolItem = this.document.querySelector('#searchToolItem');
    if (searchToolItem) {
      searchToolItem.classList.add('d-none');
    }
  }

  ngOnDestroy(): void {
    if (this.routerEvtSubc) { this.routerEvtSubc.unsubscribe(); }
    if (this.dataSubscription) { this.dataSubscription.unsubscribe(); }
    if (this.keepUrlSubscription) { this.keepUrlSubscription.unsubscribe(); }
    if (this.filterOptionSubc) {
      this.filterOptionSubc.unsubscribe();
      delete this.filterOptionSubc;
    }
    if (this.createDeptFilterOptionSubc) {
      this.createDeptFilterOptionSubc.unsubscribe();
      delete this.createDeptFilterOptionSubc;
    }

    const searchToolItem = this.document.querySelector('#searchToolItem');
    if (searchToolItem) {
      searchToolItem.classList.remove('d-none');
    }

    this.allOption$.complete();
    this.stopUpdateLimit();
    if (this.loadDataProcessUUID) {
      this.globalComponentService.closeIndeterminateProgressBar(this.loadDataProcessUUID);
      delete this.loadDataProcessUUID;
    }
  }

  /** 載入時網址上的查詢參數同步進來 */
  protected initParamsFromUrl() {
    const queryParams = this.route.snapshot.queryParams;
    if ('limit' in queryParams) { this.limit$.next(+queryParams['limit']); }
    if ('offset' in queryParams) { this.offset$.next(+queryParams['offset']); }
    if ('sort' in queryParams) { this.sort$.next(queryParams['sort']); }
    if ('order' in queryParams) { this.order$.next(queryParams['order']); }
    if ('isFuzzyMode' in queryParams) { this.isFuzzyMode$.next(queryParams['isFuzzyMode'] === 'true'); }
    if ('keyword' in queryParams) {
      this.keyword$.next(queryParams['keyword']);
      this.searchKeyword = queryParams['keyword'];
      this.onKeywordChange(queryParams['keyword']);
      if (this.isBrowser && !this.serverConfigService.isEditModeUrl) {
        this.needLog = true;
      }
    }
    if (queryParams.query) {
      const query = JSON.parse(queryParams.query);
      this.queryKeys.forEach(k => {
        if (k in query) {
          if (k === 'subject') {
            // this.searchSubject = query[k];
          } else if (!['format', 'fetchIndex', 'rights', 'desRights', 'city', 'dist'].find(s => s === k)) {
            this.searchFilter[k] = query[k];
            if (k === 'createDept') {
              this.onCreateDeptChange(query[k]);
            }
          }
        }
      });
      this.query$.next(query);
    }
  }

  /** 觀察表單參數變化 */
  protected genParamsChange$(): Observable<any> {
    return combineLatest(
      this.limit$,
      this.offset$,
      this.sort$,
      this.order$,
      this.keyword$,
      this.isFuzzyMode$,
      this.allOption$.pipe(take(1), switchMap(options => this.query$)),
    ).pipe(
      map(([limit, offset, sort, order, keyword, isFuzzyMode, query]) => {
        return {
          limit,
          offset,
          sort,
          order,
          keyword,
          isFuzzyMode,
          query: isNullOrUndefined(query) ? '' : JSON.stringify(query),
        };
      }),
      debounceTime(50),
      distinctUntilChanged((x, y) => JSON.stringify(x) === JSON.stringify(y)),
      publishReplay(1),
      refCount(),
    );
  }

  /** 參數改變就打查詢API */
  protected loadDataOnParamsChange(params$: Observable<any>) {
    this.dataSubscription = params$.pipe(
      switchMap((params) => {
        if (!this.loadDataProcessUUID) {
          this.loadDataProcessUUID = this.globalComponentService.openIndeterminateProgressBar();
        }
        this.beforeLoadData.emit();
        return combineLatest(
          this.loadOptions(params),
          this.loadData(params).pipe(
            tap(data => this.onSearchResultLoad(data))
          )
        );
      })
    ).subscribe(([options, data]) => {
      this.globalComponentService.closeIndeterminateProgressBar(this.loadDataProcessUUID);
      delete this.loadDataProcessUUID;
    }, (error) => {
      this.globalComponentService.closeIndeterminateProgressBar(this.loadDataProcessUUID);
      delete this.loadDataProcessUUID;
      console.error(error);
    });
  }

  /** 當查詢列表的結果資料載入 */
  protected onSearchResultLoad = data => {
    if (!data) { return; }

    // 更新 server 分頁位置
    this.total = data.totalSize;
    this.totalPages = Math.ceil(this.total / this.limit);

    data.records.forEach(rec => {
      // 他們的圖片有好幾個，解析後只取第一個就好
      // if (rec['imageUrl']) {
      //   const messImgArr = rec['imageUrl'].split('@#@');
      //   rec['imageUrl'] = messImgArr[0] || messImgArr[1];
      // }

      if (rec['rights']) {
        const messRightArr = rec['rights'].split('@#@');
        rec['rights'] = messRightArr[0] || messRightArr[1];
      }

      /** 影音應該讀取 iframeUrl, 但目前後端有些塞在 imageUrl, 在未來應該就不需要特別這段 */
      if (!rec['iframeUrl'] && rec.imageUrl && rec.imageUrl.includes('imedia')) {
        rec['iframeUrl'] = rec.imageUrl;
        // rec['iframeUrl'] = 'https://vod.imedia.culture.tw/s3vod/_definst_/smil:hiclouds3/imedia-multimedias/storytaiwan/32066/8d73b4fd81c640a4a43615f4e86a9ecb.smil/playlist.m3u8'
      }

      if (rec['format']) {
        const messFormatArr = rec['format'].split('@#@');
        rec['format'] = messFormatArr[0];
        switch (rec['format']) {
          case '圖像':
            rec['defaultImageUrl'] = '/assets/images/format_image.webp';
            break;
          case '影片':
            rec['defaultImageUrl'] = '/assets/images/format_video.webp';
            break;
          case '聲音':
            rec['defaultImageUrl'] = '/assets/images/format_voice.webp';
            break;
          case '文件':
            rec['defaultImageUrl'] = '/assets/images/format_doc.webp';
            break;
          case '其他':
            rec['defaultImageUrl'] = '/assets/images/format_other.webp';
            break;
          default:
            rec['defaultImageUrl'] = '/assets/images/no-pic.webp';
            break;
        }
      } else {
        rec['defaultImageUrl'] = '/assets/images/no-pic.webp';
      }
    });

    this.searchResult = data.records;
    if (this.searchResultRef) {
      (this.searchResultRef.nativeElement as HTMLElement).focus();
      window.scrollTo(0, 0);
    } else {
      window.scrollTo(0, 0);
    }

    if (this.needLog) {
      if (this.keyword) {
        if (this.isUseLog) {
          this.gALoggerService.log({
            query_keyword: this.keyword,
            search_type: this.isFuzzyMode ? 1 : 0,
            total_results: data.totalSize,
            event: 'search',
          });
          this.searchWithKeywordTimeStamp = moment().format('YYYY-MM-DDTHH:mm:ss.sss');
        }

        this.hotKeywordsService.record(this.keyword);
      } else if (this.isUseLog) {
        delete this.searchWithKeywordTimeStamp;
      }
    }

    this.dataLoaded.emit();
  }

  /** 紀錄參數到網址列上 */
  protected keepParamsToUrl(params$: Observable<any>) {
    this.keepUrlSubscription = params$.pipe(
      // skip(1),
      map(params => {
        const clone = JSON.parse(JSON.stringify(params));
        const query = (clone.query ? JSON.parse(clone.query) : {}) as SearchForm;
        ['subject', 'format', 'city', 'dist'].forEach(k => {
          if (query[k]) {
            query[k] = query[k].label;
          }
        });
        ['fetchIndex', 'rights', 'desRights'].forEach(k => {
          if (query[k]) {
            query[k] = query[k].map(opt => opt.label);
          }
        });
        clone.query = JSON.stringify(query);
        return clone;
      }),
    ).subscribe((params) => this.router.navigate(['.'], { queryParams: params, relativeTo: this.route, replaceUrl: true, queryParamsHandling: 'merge' }));
  }

  /** 載入選項 */
  protected loadOptions(params?: any) {
    const subj = new Subject<SearchOptions>();
    this.dataSearchService.getParams(params).subscribe(options => {
      if (!this.hasLoadParamOptions) {
        // 載入分類選項
        this.SUBJECT_OPTIONS = options.subject;
        if (this.query && this.query.subject) {
          this.searchSubject = this.SUBJECT_OPTIONS.find(opt => opt.label === this.query.subject);
          this.query.subject = this.searchSubject;
        }

        // 載入數位物件類型選項
        this.FORMAT_OPTIONS = options.format;
        if (this.query && this.query.format) {
          this.searchFilter.format = this.FORMAT_OPTIONS.find(opt => opt.label === this.query.format);
          this.query.format = this.searchFilter.format;
        }
      }

      // 載入資料來源機關選項
      if (this.hasLoadParamOptions) {
        this.FETCH_INDEX_OPTIONS.forEach(option => {
          const f = options.fetchIndex.find(opt => opt.label === option.label);
          option.doc_count = f.doc_count;
        });
      } else {
        this.FETCH_INDEX_OPTIONS = options.fetchIndex;
        if (this.query && this.query.fetchIndex) {
          this.searchFilter.fetchIndex = this.query.fetchIndex.map(label => {
            const f = this.FETCH_INDEX_OPTIONS.find(opt => opt.label === label);
            return f;
          }).filter(opt => !!opt);
          this.query.fetchIndex = this.searchFilter.fetchIndex;
        }
      }

      // 載入數位物件授權選項
      if (this.hasLoadParamOptions) {
        this.RIGHTS_OPTIONS.forEach(option => {
          const f = options.rights.find(opt => opt.label === option.label);
          option.doc_count = f.doc_count;
        });
      } else {
        this.RIGHTS_OPTIONS = options.rights;
        this.OPENED_RIGHTS = ['PDM', 'CC0', 'OGDL', 'CC BY', 'CC BY-SA', 'CC BY-ND'].map(s => this.RIGHTS_OPTIONS.find(opt => opt.label === s));
        this.SHARED_RIGHTS = ['CC BY-NC', 'CC BY-NC-SA', 'CC BY-NC-ND'].map(s => this.RIGHTS_OPTIONS.find(opt => opt.label === s));
        this.CLOSED_RIGHTS = ['僅限公開瀏覽'].map(s => this.RIGHTS_OPTIONS.find(opt => opt.label === s));
        if (this.query && this.query.rights) {
          this.searchFilter.rights = this.query.rights.map(label => {
            const f = this.RIGHTS_OPTIONS.find(opt => opt.label === label);
            return f;
          }).filter(opt => !!opt);
          this.query.rights = this.searchFilter.rights;
        }
      }

      // 載入文字授權選項
      if (this.hasLoadParamOptions) {
        this.DES_RIGHTS_OPTIONS.forEach(option => {
          const f = options.desRights.find(opt => opt.label === option.label);
          option.doc_count = f.doc_count;
        });
      } else {
        this.DES_RIGHTS_OPTIONS = options.desRights;
        if (this.query && this.query.desRights) {
          this.searchFilter.desRights = this.query.desRights.map(label => {
            const f = this.DES_RIGHTS_OPTIONS.find(opt => opt.label === label);
            return f;
          }).filter(opt => !!opt);
          this.query.desRights = this.searchFilter.desRights;
        }
      }

      if (!this.hasLoadParamOptions) {
        // 載入縣市選項
        this.CITY_OPTIONS = options.city;
        if (this.query && this.query.city) {
          const f = this.CITY_OPTIONS.find(opt => opt.label === this.query.city);
          if (f) {
            this.searchFilter.city = f;
            this.onCityChanged(f);
          }
        }
        this.allOption$.next(options);
        this.hasLoadParamOptions = true;
      }

      subj.next(options);
      subj.complete();
    });

    return subj;
  }

  /** 將所有查詢參數重置 */
  resetEmptySearch() {
    this.limit = checkIsMobile() ? 10 : 24;
    this.offset = 0;
    this.sort = 'relevance';
    this.order = 'desc';
    this.keyword = '';
    this.query = {};
    this.searchKeyword = undefined;
    this.searchSubject = undefined;
    this.searchFilter = {};
    this.formReset.emit();
    this.keywordsOptions = [];
    this.createDeptOptions = [];
  }

  /** 監聽關鍵字改變(，就去取自動完成關鍵字 api) */
  protected listenOnKeywordChange() {
    this.filterOptionSubc = this.searchKeyword$.pipe(
      debounceTime(500),
      distinctUntilChanged(),
      switchMap(value => {
        if (value) {
          value = value.trim();
          const body = new URLSearchParams();
          body.set('top', '10');
          if (value) { body.set('q', value); }
          return this.commonHttp.post<{ input: string; output: {[key: string]: number}[]; }>(`${this.generatorEnv.itriAutoCompleteApiHost}/v2/autocomplete`, body.toString(), {
            headers: {
              'Content-Type': 'application/x-www-form-urlencoded',
            }
          });
          // return of(( { input: value, output: [{'戰爭館': 12}, {"第二次世界大戰": 50}]} as { input: string; output: {[key: string]: number}[]; } ));
        } else {
          return of(( { input: value, output: []} as { input: string; output: {[key: string]: number}[]; } ));
        }
      }),
      map(v => {
        return v.output.map(v2 => Object.keys(v2)[0]);
      }),
    ).subscribe(options => {
      this.keywordsOptions = options;
    });
  }

  /** 監聽建檔單位改變(，就去取自動完成關鍵字 api) */
  protected listentOnCreateDeptChange() {
    this.createDeptFilterOptionSubc = this.createDept$.pipe(
      debounceTime(500),
      distinctUntilChanged(),
      switchMap(value => {
        // if (value) {
          value = value.trim();
          return this.commonHttp.get<string[]>(`${this.generatorEnv.apiHost}/api/collection/dept/autocomplete`, {
            params: {
              keyword : value,
            }
          });
        // } else {
        //   return of(([]));
        // }
      }),
    ).subscribe(options => {
      // options = options.concat(['A', 'B', 'C', 'D', 'E', 'F']);
      this.createDeptOptions = options;
    });
  }

  /** 監聽畫面參數被清空的時候 */
  protected listenOnClearParamRouteeEvt() {
    let currentQP = this.route.snapshot.queryParams;
    this.routerEvtSubc = this.router.events
    .pipe(
      filter(evt => evt instanceof NavigationEnd),
      map((evt: NavigationEnd) => {
        return this.route.snapshot.queryParams;
      }),
      filter(qp => {
        let ret: boolean;
        if (Object.keys(currentQP).length > 0 && Object.keys(qp).length === 0) {
          ret = true;
        } else {
          ret = false;
        }
        currentQP = qp;
        return ret;
      })
    ).subscribe(qp => {
      this.resetEmptySearch();
    });
  }

  protected startUpdateLimit() {
    this.updateLimitSubc = fromEvent(window, 'resize')
    .pipe(debounceTime(15))
    .subscribe(evt => {
      this.limit = checkIsMobile() ? 10 : 24;
    });
  }

  protected stopUpdateLimit() {
    if (this.updateLimitSubc) {
      this.updateLimitSubc.unsubscribe();
      delete this.updateLimitSubc;
    }
  }

  /** 當關鍵字詞改變 */
  onKeywordChange(value: string) {
    this.searchKeyword$.next(value);
  }

  /** 當關鍵字輸入框聚焦 */
  onFocusSearchKeywordInput() {
    this.skACO.isShowOptions = true;
  }

  /** 當建檔單位字詞改變 */
  onCreateDeptChange(value: string) {
    this.createDept$.next(value);
  }

  /** 選取數位物件類型 */
  selectFormat(format: SearchOption) {
    if (this.searchFilter.format !== format) {
      this.changeFilter('format', format);
    }
  }

  /** 全選所有數位物件類型 */
  selectFormatAll() {
    if (this.searchFilter.format) {
      this.changeFilter('format', null);
    }
  }

  /** 清除篩選條件 */
  removeCondition(key: string) {
    if (key === 'subject') {
      this.zone.run(() => {
        this.searchSubject = undefined;
        this.query = { ...this.query, ...{ subject: null } };
      });
    } else {
      if (key === 'city' && this.searchFilter['dist']) {
        this.changeFilter('dist', null);
      }
      this.changeFilter(key, null);
    }
  }

  /** 清除所有篩選條件 */
  removeAllCondition() {
    this.searchFilter = {};
    this.query = null;
  }

  /** 全選/全不選所有資料來源授權 */
  selectFetchIndexAll(isChecked?: boolean) {
    if (isNullOrUndefined(isChecked)) {
      isChecked = !chechArrayisMatchWithAnother(this.searchFilter.fetchIndex || [], this.FETCH_INDEX_OPTIONS);
    }

    if (isChecked) {
      this.changeFilter('fetchIndex', this.FETCH_INDEX_OPTIONS);
    } else {
      this.changeFilter('fetchIndex', null);
    }
  }

  /**
   * 選取/取消選取資料來源
   * @param val 資料來源選項
   * @param isChecked 是否被勾選
   */
   checkFetchIndex(val: SearchOption, isChecked?: boolean) {
    if (isChecked) {
      const arr = this.searchFilter.fetchIndex ? this.searchFilter.fetchIndex.slice() : [];
      arr.push(val);
      this.changeFilter('fetchIndex', arr);
    } else {
      const arr = this.searchFilter.fetchIndex.slice();
      const fidx = arr.findIndex(v => v === val);
      arr.splice(fidx, 1);
      if (arr.length) {
        this.changeFilter('fetchIndex', arr);
      } else {
        this.changeFilter('fetchIndex', null);
      }
    }
  }

  /** 全選/全不選所有數位物件授權 */
  selectRightsAll(isChecked?: boolean) {
    if (isNullOrUndefined(isChecked)) {
      isChecked = !chechArrayisMatchWithAnother(this.searchFilter.rights || [], this.RIGHTS_OPTIONS);
    }

    if (isChecked) {
      this.changeFilter('rights', this.RIGHTS_OPTIONS);
    } else {
      this.changeFilter('rights', null);
    }
  }

  /** 全選/全不選所有文字授權 */
  selectDesRightsAll(isChecked: boolean) {
    if (isChecked) {
      this.changeFilter('desRights', this.DES_RIGHTS_OPTIONS);
    } else {
      this.changeFilter('desRights', null);
    }
  }

  /**
   * 勾選一組/一個授權
   * @param key 授權鍵 (數位物件授權/文章授權)
   * @param val 要完整吻合的勾選項群/要增加的授權
   */
  checkRights(key: 'rights'|'desRights', val: SearchOption[]|SearchOption, isChecked?: boolean) {
    if (Array.isArray(val)) {
      isChecked = !chechArrayisMatchWithAnother(this.searchFilter[key] || [], val);

      if (isChecked) {
        // 照陣列裡的選
        this.changeFilter(key, val.slice());
      } else {
        // 空陣列，等於清空選項
        if (this.searchFilter[key]) {
          this.changeFilter(key, null);
        }
      }
    } else {
      if (isChecked) {
        const arr = this.searchFilter[key] ? this.searchFilter[key].slice() : [];
        arr.push(val);
        this.changeFilter(key, arr);
      } else {
        const arr = this.searchFilter[key].slice();
        const fidx = arr.findIndex(v => v === val);
        arr.splice(fidx, 1);
        if (arr.length) {
          this.changeFilter(key, arr);
        } else {
          this.changeFilter(key, null);
        }
      }
    }
  }

  /** 當篩選的縣市改變 */
  onCityChanged(city: CitySearchOption) {
    this.changeFilter('city', city || null);

    if (this.searchFilter.dist) {
      delete this.searchFilter.dist;
      this.changeFilter('dist', null);
    }

    if (city) {
      this.DIST_OPTIONS = city.data.dist;

      if (!this.searchFilter.dist && this.query.dist) { // 畫面第一次載入行政區選項，要設定進 dist
          const distName = this.query.dist;
          const f = this.DIST_OPTIONS.find(opt => opt.label === distName);
          if (f) {
            this.searchFilter.dist = f;
            this.query.dist = this.searchFilter.dist;
          }
      }
    }
  }

  /** 當篩選的行政區改變 */
  onDistChanged(dist: SearchOption) {
    this.changeFilter('dist', dist);
  }

  /** 當年份輸入框輸入文字中 */
  onInputYear(e: UIEvent, year: 'start'|'end') {
    const el = (e.target as HTMLInputElement);
    el.value = el.value.replace(/[^0-9]/g, '');
    if (+el.value < 0) {
      el.value = '0';
    }
    const nowYear = moment().get('year');
    if (+el.value > nowYear) {
      el.value = `${nowYear}`;
    }

    if (year === 'start') {
      this.searchFilter.startYear = el.value;
    } else if (year === 'end') {
      this.searchFilter.endYear = el.value;
    }
  }

  /** 當篩選的日期區間(起)改變 */
  onStartYearChange(year: string) {
    if (!year) {
      this.searchFilter.endYear = this.searchFilter.startYear;
    }
  }

  /** 當篩選的日期區間(迄)改變 */
  onEndYearChange(year: string) {
  }

  /** 當篩選的日期區間(起)失去焦點 */
  onStartYearBlur() {
    this.searchFilter.endYear = this.searchFilter.startYear;
    this.changeFilter('startYear', this.searchFilter.startYear ? this.searchFilter.startYear : null);
  }

  /** 當篩選的日期區間(迄)失去焦點 */
  onEndYearBlur() {
    if (!this.searchFilter.endYear || this.searchFilter.endYear < this.searchFilter.startYear) {
      this.searchFilter.endYear = this.searchFilter.startYear;
    }

    this.changeFilter('endYear', this.searchFilter.endYear ? this.searchFilter.endYear : null);
  }

  /** 當篩選項目改變 */
  changeFilter(key: string, value: any) {
    // 如果是未送出參數的關鍵字就復原成上次查詢的關鍵字
    if (this.keyword !== this.searchKeyword) {
      this.searchKeyword = this.keyword;
    }
    // 如果是未送出參數的分類就復原成上次查詢的分類
    if (this.query && this.query.subject !== this.searchSubject) {
      this.searchSubject = this.query.subject;
    }

    this.searchFilter[key] = value || null;
    if (value) {
      this.query = { ...this.query, ...this.searchFilter };
    } else {
      this.query = { ...this.query, ...{ [key]: null } };
      delete this.searchFilter[key];
    }
  }

  /** 當點擊畫面上的按鈕做查詢(只針對分類和關鍵字) */
  onClickSearch(e?: UIEvent) {
    if (e) {
      e.preventDefault();
    }

    if (this.searchSubject) {
      if (this.query) {
        this.query = { ...this.query, subject: this.searchSubject };
      } else {
        this.query = { subject: this.searchSubject };
      }
    } else {
      if (this.query && this.query.subject) {
        this.query = { ...this.query, subject: null };
      }
    }
    this.keyword = this.searchKeyword;

    if (this.isBrowser && !this.serverConfigService.isEditModeUrl) {
      this.needLog = true;
    }
  }

  /** 載入資料 */
  loadData(params: { limit: number; offset: number; sort: string; order: string; keyword: string; isFuzzyMode: boolean; query: string; }): Observable<ITRISearchResult> {
    if (params.keyword) {
      return this.dataSearchService.searchByITRI(params).pipe(
        tap((data: ITRISearchResult) => {
          if (!data) { return; }
          if (!data.totalSize && !params.isFuzzyMode) {
            this.globalComponentService.openInfoConfirm('找不到資料，是否切換為模糊查詢?', {
              afterConfirm: () => {
                this.isFuzzyMode = true;
              },
              afterClose: () => {},
            });
          }

          // 更新來源機關和各授權的資料數
          [['rights', this.RIGHTS_OPTIONS], ['desRights', this.DES_RIGHTS_OPTIONS]].forEach(x => {
            const key = x[0] as string;
            const options = x[1] as SearchOption[];

            if (data.groupBy[key]) {
              options.forEach(opt => {
                const f = data.groupBy[key].find(v => opt.data.key === v.key);
                if (f) { opt.itri_doc_count = f.doc_count; } else {
                  opt.itri_doc_count = 0;
                }
              });
            }
          });

          if (data.groupBy['fetchIndex']) {
            this.FETCH_INDEX_OPTIONS.forEach(opt => {
              opt.itri_doc_count = 0;
              data.groupBy['fetchIndex'].forEach(grp => {
                if (opt.data.key.indexOf(grp.key) !== -1) {
                  opt.itri_doc_count += grp.doc_count;
                }
              });
            });
          }

          // 更新相關字詞
          this.correlation = data.correlation.slice(0, 5);
        }),
      );
    } else {
      return this.dataSearchService.searchByMore(params);
    }
  }

  /**
   * 當server分頁改變
   * @param page 下一頁的頁數，從 1 開始編號
   */
  pageChange = (page: number) => {
    if (page >= 0 && page <= this.totalPages) {
      this.offset = (page - 1) * this.limit;

      // // 更新 client 分頁位置
      // if (this.total > this.offset + this.limit) {
      //   this.ctotal = this.limit;
      // } else {
      //   this.ctotal = this.total - this.offset;
      // }
      // this.ctotalPages = Math.ceil(this.ctotal / this.climit);
    }
  }

  /** 更改排序條件 */
  sortOrder(field: 'relevance'|'updateDate'|'viewCount', d: 'asc' | 'desc') {
    this.sort = field;
    this.order = d;
    this.offset = 0;
  }
}
